/**
 * AboutSection Component
 * Displays brand heritage information with craftsman image
 * Validates Requirements: 5.1, 5.2, 5.3, 5.4, 5.5
 */

import React from 'react';

export const AboutSection: React.FC = () => {
  const handleOurStoryClick = () => {
    // Scroll to contact or open modal with full story
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="about"
      className="min-h-screen bg-black py-20 px-6 flex items-center"
    >
      <div className="max-w-7xl mx-auto w-full">
        {/* Two-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Side - Craftsman Image with decorative border */}
          <div className="relative">
            {/* Yellow decorative L-shaped border */}
            <div className="absolute -left-4 top-0 w-1 h-64 bg-yellow-500"></div>
            <div className="absolute -left-4 top-0 w-32 h-1 bg-yellow-500"></div>
            <div className="absolute -left-4 bottom-0 w-1 h-32 bg-yellow-500"></div>
            <div className="absolute -left-4 bottom-0 w-20 h-1 bg-yellow-500"></div>
            
            {/* Main craftsman image */}
            <div className="relative overflow-hidden rounded-lg">
              <img
                src="https://images.unsplash.com/photo-1611085583191-a3b181a88401?w=800&h=900&fit=crop"
                alt="Jewelry craftsman at work"
                className="w-full h-[600px] object-cover"
                loading="lazy"
              />
              {/* Subtle overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="space-y-8">
            {/* Tagline */}
            <p className="text-yellow-500 text-xs font-bold tracking-[0.3em] uppercase">
              Our Heritage
            </p>

            {/* Title */}
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight">
              <span className="text-white">About </span>
              <span className="text-white italic">Siyaram Jewellers</span>
            </h2>

            {/* Description */}
            <p className="text-gray-400 text-lg leading-relaxed">
              Siyaram Jewellers has been a trusted name in fine jewellery, offering 
              beautifully crafted gold, silver, and diamond pieces. With decades of 
              experience in traditional craftsmanship and modern design, we deliver 
              jewellery that celebrates life's special moments.
            </p>

            {/* Contact Us Button */}
            <button
              onClick={handleOurStoryClick}
              className="border-2 border-yellow-500 text-yellow-500 px-8 py-3 rounded-lg font-semibold hover:bg-yellow-500 hover:text-black transition-all duration-300 uppercase text-sm tracking-wider"
              aria-label="Scroll to contact us section"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
